import React, { useEffect, useState, useRef } from 'react'
import './canvas-toBlob'
import styled, { createGlobalStyle } from 'styled-components'
import moment from 'moment'
import { useRouteMatch } from 'react-router-dom'
import { saveAs } from 'file-saver'
import html2canvas from 'html2canvas'
import { getCookie } from 'estimate_list/libs/cookie'
import { Api } from 'estimate_list/libs/api'
import { numberFormat } from 'estimate_list/libs/util'
// import { logo, banner } from './asset' // 이미지는 base64 방식

const Popup2 = () => {
    const [estimateItem, setEstimateItem] = useState(null)
    const [TotalPrice, setTotalPrice] = useState(null)
    const [itemLoading, setItemLoading] = useState(false)
    const date = new Date()

    const match = useRouteMatch()
    const view = useRef(null)

    useEffect(() => {
        setEstimateItems()
    }, []) // eslint-disable-line

    const setEstimateItems = () => {
        setItemLoading(true)
        const estimateItems = getCookie('item_est')
        if (!estimateItems) {
            setItemLoading(false)
            return
        }
        const estimateArr = estimateItems.split(',')
        const estimateCount = estimateArr.map((v) => {
            const cnt = getCookie(`cnt_${v}`)
            return `${v}|${cnt || 1}`
        })
        const type = match.params?.priceType || 'cash'
        let mallID = match.params?.idx_b_manager || 1

        Api.getEstimateList(estimateCount.join(','), type, mallID).then((response) => {
            console.log("popup2")
            if (response.data.code === 200) {
                const items = response.data.data.itemList
                setItemLoading(false)
                if (items) {
                    setEstimateItem(items)
                    let total = 0
                    items.forEach((e) => {
                        total += e.buyPrice
                    })
                    setTotalPrice(total)
                    setTimeout(() => {
                        imgSave()
                    }, 500)
                }
            }
        })
    }

    const imgSave = () => {
        html2canvas(view.current).then((canvas) => {
            canvas.toBlob(function (blob) {
                saveAs(blob, `행복쇼핑_견적_${moment(date).format('YYMMDD')}.jpg`)
            })
        })
    }

    return (
        <>
            <GlobalStyle />
            <div ref={view}>
                <Style>
                    {/*<div className="top">*/}
                    {/*    <div className="field">*/}
                    {/*        <h2>*/}
                    {/*            <img src={logo} alt="행복쇼핑" />*/}
                    {/*            PC견적서*/}
                    {/*        </h2>*/}
                    {/*        <p>www.pping.kr</p>*/}
                    {/*    </div>*/}
                    {/*    /!* <div className="field info">*/}
                    {/*        Date: {moment(date).format("YYYY.  MM.  DD")}*/}
                    {/*    </div> *!/*/}
                    {/*</div>*/}
                    {!itemLoading ? (
                        estimateItem ? (
                            <>
                                <div className="table">
                                    <div className="column head">
                                        <div className="cate">분류</div>
                                        <div className="name">상품명</div>
                                        <div className="origin_price">판매가격</div>
                                        <div className="count">수량</div>
                                        <div className="price">견적금액</div>
                                    </div>
                                    {estimateItem.map((v) => (
                                        <div className="column body" key={v.itemID}>
                                            <div className="cate">{v.cateName}</div>
                                            <div className="name">{v.itemName}</div>
                                            <div className="origin_price">
                                                <span>{numberFormat(v.price)}</span>원
                                            </div>
                                            <div className="count">{v.count}</div>
                                            <div className="price">
                                                <span>{numberFormat(v.buyPrice)}</span>원
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="total_price">
                                    <div className="estimate_info">
                                        <i className="icon-ic_excmark"/>
                                        <p>
                                            행복쇼핑의 PC견적은 부품별 최저가격 기준이므로
                                            <br />
                                            실제 구매가격이 상이할 수 있습니다.
                                        </p>
                                    </div>
                                    <div className="txt">총 견적금액</div>
                                    <div className="price">
                                        <span>{numberFormat(TotalPrice)}</span>원
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="no_item">상품견적에 담긴 상품이 없습니다.</div>
                        )
                    ) : (
                        <div className="loading">
                            <img
                                src={`${process.env.REACT_APP_SHOPPING_URL}/img_static/img_pres/_v5/happy_loading_5.gif`}
                                alt="loading"
                            />
                        </div>
                    )}
                    {/*<div className="banner">*/}
                    {/*    <img src={banner} alt="" />*/}
                    {/*</div>*/}
                    {/*<div className="estimate_info">*/}
                    {/*    <i className="icon-ic_excmark"/>*/}
                    {/*    <p>*/}
                    {/*        행복쇼핑(주)의 PC견적은 부품별 최저가격 기준이므로*/}
                    {/*        <br />*/}
                    {/*        실제 구매가격이 상이할 수 있습니다.*/}
                    {/*    </p>*/}
                    {/*</div>*/}
                </Style>
            </div>
        </>
    )
}

const GlobalStyle = createGlobalStyle`
    #header, #footer {
        display: none;
    }
`

const Style = styled.div`
    padding: 25px 20px 20px;
    width: 660px;
    margin: 0 auto;

    .top {
        display: flex;
        justify-content: space-between;
        margin: 0 0 10px;

        h2 {
            font-size: 20px;
            font-weight: 700;
            color: #0f0c33;

            img {
                margin: 0 4px 0 0;
                vertical-align: bottom;
            }
        }
        p {
            margin: 0 0 0 8px;
            color: #333;
            padding: 13px 0 0;
        }
    }
    .field {
        display: flex;
    }
    .info {
        align-items: flex-end;
    }
    .table {
        border-top: 2px solid #333;
        border-bottom: 1px solid #ccc;

        .column {
            display: flex;
            height: 40px;
            align-items: center;

            &.head {
                font-size: 13px;
                background: #f6f6f6;
                display: flex;

                div {
                    text-align: center;
                }
            }
            &.body {
                font-size: 14px;

                .cate {
                    color: #2680eb;
                    text-align: center;
                    font-weight: 700;
                }
                .origin_price {
                    span {
                        font-weight: 700;
                    }
                }
                .price {
                    span {
                        font-weight: 700;
                        color: #f34522;
                    }
                }
                .origin_price {
                    padding: 0 22px 0 0px;
                }
                .name {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 0 5px;
                }
            }
            .cate {
                width: 90px;
            }
            .name {
                flex: 1;
                letter-spacing: -0.35px;
            }
            .origin_price {
                width: 95px;
                text-align: right;
            }
            .count {
                width: 35px;
                text-align: center;
            }
            .price {
                width: 95px;
                text-align: right;
            }
        }
    }
    .total_price {
        display: flex;
        margin: 6px 0 0;
        display: flex;
        padding: 0 10px;
        height: 60px;
        align-items: center;
        justify-content: space-between;
        background: #ecf3fd;
        border-top: 1px solid #418ded;
        border-bottom: 1px solid #418ded;

        .txt {
            color: #2680eb;
            font-size: 19px;
            font-weight: 700;
        }
        .price {
            font-size: 18px;
            font-weight: 700;

            span {
                font-size: 24px;
                color: #f34522;
            }
        }
    }
    //.banner {
    //    margin: 10px 0 0;
    //    text-align: center;
    //}
    .estimate_info {
        display: flex;
        margin: 0px 0 0;
        padding: 0 15px;
        //background: #f3f3f3;
        align-items: center;
        height: 60px;

        i {
            display: flex;
            width: 30px;
            height: 30px;
            background: #ccc;
            border-radius: 15px;
            margin: 0 12px 0 0;
            color: #fff;
            font-size: 14px;
            align-items: center;
            justify-content: center;
        }
        p {
            font-size: 12px;
            line-height: 16px;
            color: #999;
        }
    }
    .no_item {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        height: 160px;
    }
    .loading {
        display: flex;
        height: 160px;
        justify-content: center;
        align-items: center;

        img {
            width: 60px;
            height: auto;
        }
    }
`

export default Popup2



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate_save/popup2.js